import { useNavigate } from "react-router-dom";
import { useApp } from "../lib/store";
import { ListPage } from "../components/ListPage";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { api, errDetail } from "../lib/api";
import { toast } from "sonner";
import { ArrowRightCircle, Zap } from "lucide-react";

const STATUS = {
  New: "bg-blue-50 text-blue-700", Contacted: "bg-indigo-50 text-indigo-700",
  Qualified: "bg-amber-50 text-amber-700", Converted: "bg-emerald-100 text-emerald-800",
  Disqualified: "bg-slate-100 text-slate-500",
};

export default function Leads() {
  const { t, canWrite, plLabel } = useApp();
  const navigate = useNavigate();

  const convert = async (e, r, reload) => {
    e.stopPropagation();
    try {
      const res = await api.post(`/leads/${r.id}/convert`);
      toast.success(`${t("converted")}: ${res.data.account.name}`);
      reload?.();
      navigate(`/accounts/${res.data.account.id}`);
    } catch (err) { toast.error(errDetail(err)); }
  };

  const columns = (reload) => [
    { key: "company", label: t("company"), render: (r) => <span className="font-medium text-[#1B2A4A]">{r.company}</span> },
    { key: "contact_name", label: t("contact") },
    { key: "source", label: t("source"), picklist: "lead_sources" },
    { key: "status", label: t("status"), render: (r) => <Badge className={`${STATUS[r.status] || ""} hover:bg-inherit`}>{plLabel("lead_statuses", r.status)}</Badge> },
    { key: "segment", label: t("segment") },
    { key: "estimated_volume", label: t("estimated_volume"), align: "right", render: (r) => (r.estimated_volume || 0).toLocaleString("de-DE") },
    { key: "product_interest", label: t("product_interest"), picklist: "product_types" },
    {
      key: "score", label: t("score"), render: (r) => (
        <span className={`inline-flex items-center justify-center h-7 w-10 rounded-md font-mono font-bold text-xs ${
          r.score >= 60 ? "bg-emerald-100 text-emerald-800" : r.score >= 35 ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600"}`}
          data-testid="lead-score-badge">
          {r.score ?? 0}
        </span>
      ),
    },
    {
      key: "actions", label: "", render: (r) =>
        canWrite && r.status !== "Converted" ? (
          <Button size="sm" variant="outline" data-testid={`lead-convert-btn-${r.id}`}
            className="text-[#1B2A4A] border-[#F5A623] hover:bg-amber-50"
            onClick={(e) => convert(e, r, reload)}>
            <ArrowRightCircle className="h-3.5 w-3.5 mr-1" />{t("convert")}
          </Button>
        ) : null,
    },
  ];

  return <ListPage module="leads" titleKey="leads" columns={columns()}
    extraToolbar={() => canWrite && (
      <Button size="sm" data-testid="tradefair-mode-btn" onClick={() => navigate("/tradefair")}
        className="bg-[#1B2A4A] hover:bg-[#2a3d63] text-white rounded-full">
        <Zap className="h-3.5 w-3.5 mr-1" />{t("tradefair")}
      </Button>
    )} />;
}
